// account systerm type
export const QR_CODE = 'qr_code';
export const NORMAL_ACCOUNT_TYPE = 'normal';
export const XL_ACCOUNT_TYPE = 'xl';
export const LALAMOVE_ACCOUNT_TYPE = 'lalamove';
export const NOT_WECHAT_BROWSER = 'not_wechat_browser';
export const USER_TYPE = {
  user: 'user',
  driver: 'driver'
};
// host config saved in localStorage
export const XL_HOST = 'xl_host';
export const LOGIN_HOST = 'login_host';

export const PRIVACYANDAGREE = {
  user: {
    privacy: 'https://user-h5.xiaolachuxing.com/index/agreement/privacy',
    agree: 'https://user-h5.xiaolachuxing.com/index/agreement/software'
  },
  driver: {
    privacy: 'https://driver-h5.xiaolachuxing.com/index/agreement/privacy',
    agree: 'https://driver-h5.xiaolachuxing.com/index/agreement/software'
  }
};
